var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-portlet"},[_c('div',{staticClass:"kt-portlet__body",staticStyle:{"color":"black","background-color":"#fff"}},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-center"},[_c('h4',{staticClass:"fix-margin"},[_vm._v("\n                "+_vm._s(_vm.accountingStatistics)+"\n            ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }